module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-LightItalic-8a33155f78f8184dbe648ac69d6aa76d.ttf";